const { PermCameraMicRounded } = require("@material-ui/icons");
// const appsetting = require('json./');
const Global = {
  //BASE_URL: "http://localhost:5034/",
  //BASE_URL: "https://pmcrm.biztran.in/",
  BASE_URL: "https://pmcrm.demo.biztran.in/",
  REPORT_URL: "https://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport",
  // REPORT_URL: "http://localhost:49490/WebService.asmx/PrintReport",
  //REPORT_URL: "http://localhost:801/WebService.asmx/PrintReport",
  //REPORT_URL: "http://pmcrm.rpt.biztran.in/WebService.asmx/PrintReport",
  form_list: [
    {
      name: "Dashboard",
      path: "/",
      icon: "Home",
      isMenuItem: 1,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    {
      name: "CRM - Sales",
      path: "/crm",
      icon: "Extension",
      isMenuItem: 1,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [
        {
          name: "Account",
          path: "/account",
          icon: "AccountBoxSmall",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager"],
        },
        {
          name: "Lead",
          path: "/lead",
          icon: "AccessibilityNewIconSmall",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Opportunities",
          path: "/opportunities",
          icon: "BusinessCenterIconSmall",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Quotation",
          path: "/quotation",
          icon: "QuotationIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Sales Order",
          path: "/SalesOrder",
          icon: "SalesOrderIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Activities",
          path: "/activities",
          icon: "ActivityIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Message Center",
          path: "/MessageCenter",
          icon: "CustomerCompaintIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Sales Target vs Actual",
          path: "/SalesTargetvsActual",
          icon: "SalesTargetVsActualIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Quotation Analysis",
          path: "/QuotationAnalysis",
          icon: "QuotationAnalysisIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Quotation Analysis Country Wise",
          path: "/QuotationAnalysisCountryWise",
          icon: "CountryIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Quotation Analysis Product Wise",
          path: "/QuotationAnalysisProductWise",
          icon: "AccountTreeIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager"],
        },
        {
          name: "Quotation Analysis Team Wise",
          path: "/QuotationAnalysisTeamWise",
          icon: "GroupWorkIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager"],
        },
        {
          name: "Quotation Lost Analysis",
          path: "/QuotationLostAnalysis",
          icon: "QuotationLostAnalysisIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager"],
        },
      ],
    },
    {
      name: "CRM - Service",
      path: "/crmservice",
      icon: "Extension",
      isMenuItem: 1,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [
        {
          name: "Customer Compaints",
          path: "/customer",
          icon: "CustomerCompaintIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
      ],
    },
    {
      name: "Sales",
      path: "/sales",
      icon: "Build",
      isMenuItem: 1,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [
        {
          name: "Delivery Challan",
          path: "/deliveryChallan",
          icon: "DeliveryIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Dispatch Management",
          path: "/dispatchManagement",
          icon: "DispatchManagementIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Invoice",
          path: "/invoice",
          icon: "InvoiceIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Sales Analysis",
          path: "/salesAnalysis",
          icon: "SalesAnalysisIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Sales Analysis Country Wise",
          path: "/salesAnalysisCountryWise",
          icon: "CountryIcon",
          //icon: "CountryIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Sales Analysis Product Wise",
          path: "/salesAnalysisProductWise",
          icon: "AccountTreeIcon",
          //icon: "ProductIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "Sales Analysis Sales Team Wise",
          path: "/salesAnalysisSalesTeamWise",
          icon: "GroupWorkIcon",
          //icon: "GroupWorkIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
        },
        {
          name: "SalesReportTally",
          path: "/SalesReportTally",
          icon: "InvoiceIcon",
          isMenuItem: 1,
          Authorization: ["Admin"],
        },
      ],
    },
    {
      name: "Inventory",
      path: "/inventory",
      icon: "AddShoppingCart",
      isMenuItem: 1,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant", "Store/Production", "Store Support"],
      subMenu: [
        {
          name: "FG Inward To Warehouse",
          path: "/fginward",
          icon: "FGInwardToWarehouseIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Store/Production", "Store Support"],
        },
        {
          name: "Stock Inward",
          path: "/StockInward",
          icon: "StockInwardIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Store/Production", "Store Support"],
        },
        {
          name: "Stock Outward",
          // path: "/stockOut",
          path: "/StockOutward",
          icon: "StockOutwardIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Store/Production", "Store Support"],
        },
        {
          name: "Stock Adjustment",
          // path: "/stockOut",
          path: "/StockAdjustment",
          icon: "StockOutwardIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Store/Production", "Store Support"],
        },
        {
          name: "Stock Ledger",
          path: "/stockLedger",
          icon: "StockLedgerIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Store/Production", "Store Support"],
        },
        {
          name: "Stock Status",
          path: "/stockStatus",
          icon: "StockStatusIcon",
          isMenuItem: 1,
          Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant", "Store/Production", "Store Support"],
        },
      ],
    },
    {
      name: "Masters",
      path: "/masters",
      icon: "EventNote",
      isMenuItem: 1,
      Authorization: ["Admin", "Store Support"],
      subMenu: [
        {
          name: "Product Master",
          path: "/product",
          icon: "FeaturedPlayListIconSmall",
          isMenuItem: 1,
          Authorization: ["Admin", "Store Support"],
        },
        {
          name: "User Master",
          path: "/user",
          icon: "AccountBoxSmall",
          isMenuItem: 1,
          Authorization: ["Admin"],
        },
        {
          name: "Primary Master",
          path: "/primary",
          icon: "EventNoteSmall",
          isMenuItem: 1,
          Authorization: ["Admin"],
        },
      ],
    },
    {
      name: "Account View",
      path: "/account/AccountView",
      isMenuItem: 0,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    {
      name: "Lead View",
      path: "/lead/LeadView",
      isMenuItem: 0,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    {
      name: "Opportunity View",
      path: "/Opportunity/OpportunityView",
      isMenuItem: 0,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    {
      name: "Quotation View",
      path: "/quotation/QuotationView",
      isMenuItem: 0,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    {
      name: "Product View",
      path: "/product/ProductView",
      isMenuItem: 0,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    {
      name: "Sales Order View",
      path: "/SalesOrder/SalesOrderView",
      isMenuItem: 0,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    {
      name: "Delivery Challan View",
      path: "/deliveryChallan/DeliveryChallanView",
      isMenuItem: 0,
      Authorization: ["Admin", "Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    {
      name: "Stock Outward View",
      path: "/StockOutwards/StockOutwardView",
      isMenuItem: 0,
      Authorization: ["Admin", "Store Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    {
      name: "Stock Inward View",
      path: "/StockInwards/StockInwardView",
      isMenuItem: 0,
      Authorization: ["Admin", "Store Sales Manager", "Sales Executive", "Sales Assistant"],
      subMenu: [],
    },
    // {
    //   name: "Stock Adjustment View",
    //   path: "/StockAdjustment/StockAdjustmentView",
    //   isMenuItem: 0,
    //   Authorization: ["Admin", "Sales Manager", "Sales Executive"],
    //   subMenu: [],
    // },
  ],
};

module.exports = Global;
